// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_TourReview_container__4nZK1","tourReviewsSlide":"Home_TourReview_tourReviewsSlide__6DMfL","carousel":"Home_TourReview_carousel__SzkFN"};